import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { DO_NOT_CHANGE_NO_CLIENT_VERSION, DO_NOT_CHANGE_NUM_RETRIES, DO_NOT_CHANGE_TIMEOUT, REASON, } from '#pplx/frontend/apps/ask/finance/queries/constants.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
import { financeClient } from '#pplx_generated/typespec/rest/finance/client.js';
export const getPoliticiansKey = () => {
    return QueryClientHelper.makeEphemeralQueryKey('/rest/finance/politicians');
};
export const getPoliticians = async () => {
    const { data, error, response } = await financeClient.GET('/rest/finance/politicians', REASON, {
        timeoutMs: DO_NOT_CHANGE_TIMEOUT,
        numRetries: DO_NOT_CHANGE_NUM_RETRIES,
        shouldNotAddSourceVersionQueryParams: DO_NOT_CHANGE_NO_CLIENT_VERSION,
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
//# sourceMappingURL=getPoliticians.js.map